import { render, staticRenderFns } from "./SelectorVcoin.vue?vue&type=template&id=a1faf96a&"
import script from "./SelectorVcoin.vue?vue&type=script&lang=js&"
export * from "./SelectorVcoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports